<div>
  <Heading bold sm border-bottom="3" mt="md" pb="xs">
    Filtros
  </Heading>

  <Panel my="xs">
    {#each filters as filter}
      <span class="filter-item">
        <span class="filter-item-label">
          {filter.label}
        </span>
        <select class="filter-item-condition" bind:value={filter.condition}>
          <option value="eq">igual a</option>
          <option value="neq">distinto de</option>
          <option value="like">contiene</option>
          <option value="gt">mayor que</option>
          <option value="lt">menor que</option>
        </select>
        <span class="filter-item-value">
          <input bind:value={filter.value} />
        </span>
        <button class="filter-item-delete-btn"
          on:click={() => {deleteFilter(filter.name)}}
          >X</button>
      </span>
    {/each}
  </Panel>

  <select 
    class="filter-selector" 
    bind:value={selected}>
    <option value="-1">Agregar otro filtro ...</option>
    {#each meta.sections as section}
      <optgroup label={section.label}>
        {#each section.controls as control}
          <option value={control.property}>{control.label}</option>
        {/each}
      </optgroup>
    {/each}
  </select>

</div>

<script>
  import { tick } from 'svelte';
  import { Heading, Panel } from 'svelte-stylo'
  import { RecordDef, is } from '@/models'

  export let meta = {};
  export let filters = [];

  let selected = null;

  $: if (selected !== null) { 
    filterSelected(); 
  }

  function filterSelected() {
    if (! selected) return;
    filters = filters.concat([{
      name: selected,
      label: meta.dictionary[selected].label,
      condition: "eq",
      value: null
    }]);
    selected = "-1";
  }

  function deleteFilter(name) {
    filters = filters.filter((t) => {
      return (t.name !== name)
    });
  }

</script>

<style>

  .filters-list {
    font-size: 14px;
    line-height: 20px;
    margin-top: 0.5rem;
  }

  .filters-list-title {
    margin-top: 12px;
    font-size: 14px;
    color: #889;
  }

  .filter-item {
    display: block;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 2px;
    margin-bottom: 4px;
    padding: 1px 0;
  }

  .filter-item-label {
    font-size: 14px;
    padding: 4px 0px 4px 12px;;
    margin: 0;
    display: inline-block;
    color: #2b2b6f;
  }

  .filter-item-condition {
    border: none;
    background-color: transparent;
    margin: 0;
    cursor: pointer;
    color: #2b2b6f;
  }

  .filter-item-value input {
    margin: 0;
    padding: 2px;
    width: 10ch;
    margin-right: 4px;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #2b2b6f;
    border-radius: 0;
    color: #2b2b6f;
  }

  .filter-item-delete-btn {
    background-color: transparent;
    font-size: 14px;
    border: none;
    margin: 0 4px;
    padding: 0 8px 0 8px;
    display: inline-block;
    cursor: pointer;
    color: #9d9d9d;
    float: right;
  }

  .filter-selector {
    border: none;
    background-color: #eee;
    border-radius: 4px;
    padding: 0.25rem 0.5rem;
    font-size: 14px;
    color: #ab3a3a;
    margin-top: 2px;
    width: 19ch;
  }

</style>